import store from '../store'
import axios from 'axios'

let instance
/* eslint-disable */
instance = axios.create()
instance.defaults.headers.common.client_id = 'geclisaAutoRecepcion'

instance.interceptors.request.use(async (config) => {
  // Esperar hasta que la URL de la API esté disponible
  let url = store.state.apiUrl
  let attempts = 0
  const maxAttempts = 50 // 5 segundos máximo (50 * 100ms)
  
  while (!url && attempts < maxAttempts) {
    await new Promise(resolve => setTimeout(resolve, 200))
    url = store.state.apiUrl
    attempts++
  }
  
  if (!url) {
    throw new Error('API URL no disponible después de esperar. Verifique la configuración de la aplicación.')
  }
  
  config.baseURL = `${url}/api`
  store.commit('incrementAjaxCounter')
  return config
})

instance.interceptors.response.use(response => {
  store.commit('decrementAjaxCounter')
  return response
}, error => {
  // hay que hacer retry en los NOT FOUND porque a veces no alcanza a levantar el conn.json
  store.commit('decrementAjaxCounter')
  if (!error.config.__isRetryRequest && error.response.status == 404) {
    error.config.__isRetryRequest = true
    return axios(error.config)
  }
  return Promise.reject(error)
})
export default instance
